import { Element, Node } from 'slate';
import { EditorState } from '../Editor.types';
import { unsupportedType } from '../plugins/unsupported/UnsupportedElement';
import { convertLegacyContent } from './convertLegacyContent';

/**
 * convertUnsupported
 *
 * Converts unsupported file types
 */
export const convertUnsupported = (editorState: EditorState): EditorState => {
  let { entities } = editorState.context;
  let value: Node[] = [];

  editorState.value.forEach((val) => {
    if (
      Element.isElement(val) &&
      val.type === unsupportedType &&
      val.legacyContent
    ) {
      const converted = convertLegacyContent({
        blocks: [val.legacyContent],
        entityMap: {},
      });

      entities = { ...entities, ...converted.context.entities };
      value = value.concat(converted.value);
    } else {
      value.push(val);
    }
  });

  return {
    value,
    context: {
      ...editorState.context,
      entities,
    },
  };
};
